/* tslint:disable */
/* eslint-disable */
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";

import { HttpClient, HttpContext, HttpResponse } from "@angular/common/http";

import { ReverseZoneExternalRead } from "../../models/reverse-zone-external-read";
import { ReverseZonePrimaryWithRecordsRead } from "../../models/reverse-zone-primary-with-records-read";
import { RequestBuilder } from "../../request-builder";
import { StrictHttpResponse } from "../../strict-http-response";

export interface ReadReverseZone$Params {
  organisation_id: string;
  reverse_zone_id: number;
}

export function readReverseZone(
  http: HttpClient,
  rootUrl: string,
  params: ReadReverseZone$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ReverseZonePrimaryWithRecordsRead | ReverseZoneExternalRead>> {
  const rb = new RequestBuilder(rootUrl, readReverseZone.PATH, "get");
  if (params) {
    rb.path("organisation_id", params.organisation_id, {});
    rb.path("reverse_zone_id", params.reverse_zone_id, {});
  }

  // add this header so we are able to examine the failure response
  // otherwise it's intercepted by the http interceptor
  rb.header("x-ignore-interceptor", "1");

  const responseType = "json";
  return http.request(rb.build({ responseType, accept: "application/json", context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReverseZonePrimaryWithRecordsRead | ReverseZoneExternalRead>;
    }),
  );
}

readReverseZone.PATH = "/surfdomeinen/organisations/{organisation_id}/reverse/{reverse_zone_id}";
